import * as React from "react";

export const SvgEdit = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="m18.193 1.607-.022-.02A2.237 2.237 0 0 0 16.66 1c-.629 0-1.233.266-1.656.73l-8.016 8.775a.774.774 0 0 0-.162.277l-.943 2.825a1.075 1.075 0 0 0 1.45 1.324l2.728-1.194a.774.774 0 0 0 .261-.187l8.015-8.775a2.245 2.245 0 0 0-.143-3.168ZM7.688 13.086l.553-1.658.047-.051 1.048.957-.047.051-1.601.7Zm9.506-9.354-6.814 7.46-1.048-.958 6.813-7.46a.693.693 0 0 1 .982-.044l.022.02a.696.696 0 0 1 .045.982Z"
			fill={props.color ?? "#A8A8A8"}
		/>
		<path
			d="M16.638 8.14a.774.774 0 0 0-.774.774v6.57a1.97 1.97 0 0 1-1.968 1.968h-9.38a1.97 1.97 0 0 1-1.968-1.968V6.18a1.97 1.97 0 0 1 1.968-1.968h6.789a.774.774 0 0 0 0-1.547h-6.79A3.52 3.52 0 0 0 1 6.18v9.304A3.52 3.52 0 0 0 4.516 19h9.38a3.52 3.52 0 0 0 3.515-3.516v-6.57a.774.774 0 0 0-.773-.774Z"
			fill={props.color ?? "#A8A8A8"}
		/>
	</svg>
);
